export const SET_CLIENT_TEXT = "SET_CLIENT_TEXT";

export const initialState = {
    clientText: "",
};

const ClientDashboardTextReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_CLIENT_TEXT:
            return { clientText: payload };

        default:
            return state;
    }
};

export const setClientDashboardText = (payload) => {
    return (dispatch) => {
        dispatch({
            type: SET_CLIENT_TEXT,
            payload,
        });
    };
};

export default ClientDashboardTextReducer;
